<template>
  <div>
      <div class="pt-3" v-for="f in comentarios" :key="f.id_comentario">
        
        <div class="card" v-if="rol == 0">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-10">
                        <img class="img" :src="getUrl(f.avatar)" alt="User Image">         
                        <router-link :to="{ name: 'calificacion', params: {id: f.id_usuario}}">
                            @{{f.usuario}}
                        </router-link>
                        <img :src="getBandera(f.pais_region)" class="flag">
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <span>
                            <small> Ejecución del proyecto: <i>{{f.titulo_proyecto}} &nbsp;&nbsp; {{f.producto}} &nbsp;&nbsp; {{f.version}}</i> </small>
                        </span>
                    </div>
                    <div class="col-sm-2">
                        <star-rating class="float-right" :increment="0.1" :rating="makeNumber(f.calificacionE)" :star-size="20" :read-only="true"/>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <p>{{f.comentarioE}}</p>
                <span> <i> <small> {{fechaFormat(f.fechaE)}} </small> </i> </span>
            </div>
        </div>
        
        <div class="card" v-else>
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-10">
                        <img class="img" :src="getUrl(f.avatar)" alt="User Image">
                        <router-link :to="{ name: 'calificacion', params: {id: f.id_empresa}}">
                            @{{f.usuario}}
                        </router-link>
                        <img :src="getBandera(f.pais_region)" class="flag">
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <span> 
                            <small> Ejecución del proyecto: <i>{{f.titulo_proyecto}} &nbsp;&nbsp;{{f.producto}}&nbsp;&nbsp; {{f.version}}</i> </small>
                        </span> 
                    </div>
                    <div class="col-sm-2">
                        <star-rating class="float-right" :increment="0.1" :rating="makeNumber(f.calificacionU)" :star-size="20" :read-only="true"/>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <p>{{f.comentarioU}}</p>
                <span> <i> <small> {{fechaFormat(f.fechaU)}} </small> </i> </span>
            </div>
        </div>
    </div>
  </div>
  
</template>

<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'
import StarRating from 'vue-star-rating'

export default {
name: 'Resenas',
mixins: [ globalFunctions ],
components:{ StarRating },
props:['comentarios', 'rol'],
data () {
    return { 
    }
},
methods:{ },
computed:{
    ...mapState(['url'])
},
mounted(){}

}
</script>

<style scoped>

.icon{
    font-size: 30px;
}

.flag{
    width: 35px;
    height: 20px;
}

.card-header{
    background-color: white;
}

</style>>




// WEBPACK FOOTER //
// src/components/Resenas.vue